import { render, staticRenderFns } from "./MaterialLog.vue?vue&type=template&id=afaf69b4&"
import script from "./MaterialLog.js?vue&type=script&lang=js&"
export * from "./MaterialLog.js?vue&type=script&lang=js&"
import style0 from "./MaterialLog.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports